<template>
  <hr class="Divider m-0" />
</template>

<script>

export default {
  name: 'Divider'
}

</script>

<style scoped>

.Divider {
  height: 1px;

	@apply 
		border-none
		bg-dull;
}

</style>
